import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ReportTemplateCellApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'reportTemplateCell';
    }

}